const ExternalServiceClientType = {
  Person: 'I',
  Company: 'E',
};

const ExternalServiceGenderType = {
  Male: 'M',
  Female: 'F',
  NonBinary: 'X',
  None: '',
};

module.exports = {
  ExternalServiceClientType,
  ExternalServiceGenderType,
};
